// @param {Object} `obj` The item to test
// @return {Boolean} True if `obj` is an Node.ELEMENT_NODE
// @usage du.isElement(thatItem);
// @source <http://underscorejs.org/#isElement>
// @about Is a given value a DOM element
module.exports = (obj) => {
	return !!(obj && obj.nodeType === 1);
};
